import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"

import Column from "./Column"

export default function LengthLimitedTextField({
  label,
  placeholder,
  value,
  setValue,
  maxLength,
  multiline,
  required,
  helperText,
  error,
  size = "small",
  textFieldProps = {},
}) {
  function handleValueChanged(e) {
    const newValue = e.target.value
    if (newValue.length <= maxLength) {
      setValue(newValue)
    }
  }
  return (
    <Column sx={{ gap: 1, width: "100%" }}>
      <TextField
        label={label}
        placeholder={placeholder}
        value={value}
        onChange={handleValueChanged}
        fullWidth
        multiline={multiline}
        rows={3}
        required={required}
        error={error}
        helperText={helperText}
        size={size}
        {...textFieldProps}
      />
      <Typography
        variant="body1"
        color="text.secondary"
        sx={{ alignSelf: "flex-end", lineHeight: 1 }}
      >
        {value.length}/{maxLength}
      </Typography>
    </Column>
  )
}
